<template>
  <div>
    <page-header :title="$t('bill.brand_cost')">
      <div slot="res-status-tab" style="position: absolute; right: 0; top: 10px;">
        <bill-config :billShared.sync="billShared" :projectShared.sync="projectShared" :projectSharedShow="projectSharedShow" @update:currency="currencyChange" />
      </div>
    </page-header>
    <page-body>
      <brand-list :id="listId" :getParams="getParams" :billShared="billShared" :projectShared="projectShared" />
    </page-body>
  </div>
</template>

<script>
import shareMixin from '@Bill/mixins/share'
import BillConfig from '@Bill/sections/BillConfig'
import BrandList from './components/List'

export default {
  name: 'BrandIndex',
  components: {
    BrandList,
    BillConfig,
  },
  mixins: [shareMixin],
  data () {
    return {
      listId: 'BrandList',
    }
  },
  computed: {
    getParams () {
      return {}
    },
  },
}
</script>
